import { render, staticRenderFns } from "./BtAutocomplete.vue?vue&type=template&id=55f2be2d&"
import script from "./BtAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BtAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports